import { useMemo } from "react";
import { ExtraStateContext } from "..";
import type { TableColumn } from "../../../../../../components/table";
import { GrantedArea, Photo } from "../../../../components/table-columns";
import { useProcess } from "../../../../process-context";
import { FileAttachmentCard } from "../../../../upload";
import { CopyButton } from "../../../../../../components/Copy-Button/copy";

export const useShortTermTableColumns = () => {
  const { isRenew } = useProcess<ExtraStateContext>();

  return useMemo<TableColumn<any>[]>(() => {
    return [
      {
        title: "STT",
        renderCell: (row, rowNumber) => rowNumber,
      },
      {
        title: "Đơn vị",
        renderCell: (row) => row.unit,
      },
      {
        title: "Họ và tên",
        renderCell: (row) => <>{row.name} <CopyButton value={row.name}/></>,
      },
      {
        title: "Nam/Nữ",
        renderCell: (row) => row.sex,
      },
      {
        title: "CMND/CCCD/Hộ chiếu",
        renderCell: (row) => <>{row.personalId} <CopyButton value={row.personalId}/></>,
      },
      {
        title: "Chức vụ",
        renderCell: (row) => row.regency,
      },
      {
        hidden: !isRenew,
        title: "Số thẻ KSAN đã cấp (Nếu có)",
        renderCell: (row) => row.KSANCardNumberIssued,
      },
      {
        title: "Thời hạn cấp",
        renderCell: (row) => row.grantTerm,
      },
      {
        title: "Khu vực đề nghị",
        renderCell: (row) => <GrantedArea data={row.grantedArea ?? []} />,
      },
      {
        title: "CMND Photo Công Chứng (mặt trước)",
        renderCell: (row) => <Photo src={row.photocopyOfIDCard} />,
      },
      {
        title: "CMND Photo Công Chứng (mặt sau)",
        renderCell: (row) => <Photo src={row.photocopyOfIDCardOpSide} />,
      },
      {
        hidden: !isRenew,
        title: "Đơn cớ mất",
        renderCell: (row) => (
          <FileAttachmentCard listFile={row.excuse ? JSON.parse(row.excuse) : []} />
        ),
      },
      {
        title: "Ghi chú",
        renderCell: (row) => row.note,
      },
    ];
  }, [isRenew]);
};

export const useLongTermTableColumns = () => {
  const { isRenew, isEvict } = useProcess<ExtraStateContext>();

  return useMemo<TableColumn<any>[]>(() => {
    return [
      {
        title: "STT",
        renderCell: (row, rowNumber) => rowNumber,
      },
      {
        title: "Đơn vị",
        renderCell: (row) => row.unit,
      },
      {
        title: "Họ và tên",
        renderCell: (row) => <>{row.name} <CopyButton value={row.name}/></>,
      },
      {
        title: "Nam/Nữ",
        renderCell: (row) => row.sex,
      },
      {
        title: "CMND/CCCD/Hộ chiếu",
        renderCell: (row) => <>{row.personalId} <CopyButton value={row.personalId}/></>,
      },
      {
        title: "Chức vụ",
        renderCell: (row) => row.regency,
      },
      {
        hidden: !isRenew && !isEvict,
        title: "Số thẻ KSAN đã cấp",
        renderCell: (row) => row.KSANCardNumberIssued,
      },
      {
        title: "Thời hạn cấp",
        renderCell: (row) => row.grantTerm,
      },
      {
        title: "Khu vực đề nghị",
        renderCell: (row) => <GrantedArea data={row.grantedArea ?? []} />,
      },
      {
        title: "Ảnh Thẻ 4x6",
        renderCell: (row) => <Photo src={row.cardPhoto} />,
      },
      {
        title: "Bản Photo Lý Lịch Tư Pháp",
        renderCell: (row) => <Photo src={row.photocopyOfCriminalRecord} />,
      },
      {
        title: "Bản khai cá nhân",
        renderCell: (row) => <Photo src={row.personalStatement} />,
      },
      {
        title: "Bản Photo Hợp Đồng Lao Động Giữa Người Lao Động Với Công Ty",
        renderCell: (row) => <Photo src={row.photocopyOfLaborContract} />,
      },
      {
        hidden: !isRenew && !isEvict,
        title: "Bản Photo Ảnh Thẻ KSAN Cũ",
        renderCell: (row) => <Photo src={row.photoOldKSAN} />,
      },
      {
        hidden: !isRenew,
        title: "Đơn cớ mất",
        renderCell: (row) => <FileAttachmentCard listFile={row.ExcuseLose ? JSON.parse(row.ExcuseLose) : []} />,
      },
      {
        title: "Ghi chú",
        renderCell: (row) => row.note,
      },
    ];
  }, [isEvict, isRenew]);
};
